var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "fade-fast" },
      on: { enter: _vm.toggleOffset, "after-leave": _vm.toggleOffset }
    },
    [
      _vm.show
        ? _c(
            "div",
            {
              class: [
                "page-overlay",
                {
                  "page-overlay--open": _vm.show,
                  "page-overlay--auto-height": _vm.autoHeight
                }
              ]
            },
            [
              _c(
                "div",
                {
                  staticClass: "page-overlay__body",
                  style: { width: _vm.width + "px" }
                },
                [
                  _vm._t("default"),
                  _c(
                    "btn",
                    {
                      staticClass: "page-overlay__close btn--primary",
                      attrs: { tag: "control" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 12 12"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M12 .8l-.8-.8L6 5.2.8 0 0 .8 5.2 6 0 11.2l.8.8L6 6.8l5.2 5.2.8-.8L6.8 6z"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                2
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3212b794", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3212b794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PageOverlay.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3212b794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PageOverlay.vue
// module chunks = 5